import { Alert, AlertIcon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const SupplierCountIndicator = ({
  selectedCount,
  maxParticipants,
}: {
  selectedCount: number;
  maxParticipants?: number;
}) => {
  const { t } = useTranslation();
  if (maxParticipants == null) return null;
  const overLimit = selectedCount > maxParticipants;
  return (
    <Stack spacing="2">
      <Text fontSize="sm" color={overLimit ? "smError" : "smMuted"} px="1">
        {t("{{count}} of {{max}} suppliers selected", { count: selectedCount, max: maxParticipants })}
      </Text>
      {overLimit && (
        <Alert status="warning" rounded="md" fontSize="sm">
          <AlertIcon />
          {t(
            "The contract details state up to {{max}} suppliers, but you have selected {{count}}. You can still proceed.",
            { count: selectedCount, max: maxParticipants },
          )}
        </Alert>
      )}
    </Stack>
  );
};
